// angular
import { Component, effect, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
// components
import { PaginationComponent } from '@app/core/components/pagination/pagination.component';
import { SupplierCardComponent } from '@app/core/components/supplier-card/supplier-card.component';
import { NoContentComponent } from '@app/core/components/no-content/no-content.component';
import { SupplierCardSkeletonComponent } from '@app/core/components/supplier-card/supplier-card-skeleton/supplier-card-skeleton.component';
// services
import { SuppliersService } from '@app/+suppliers/shared/services/suppliers.service';
// interfaces & constants
import { IBusiness } from '@app/+suppliers/shared/interfaces/business.interface';
import { industriesSortItems } from '@app/+suppliers/shared/constants/industries-sort-items.const';

@Component({
  selector: 'pwj-cards-list',
  standalone: true,
  imports: [
    SupplierCardComponent,
    PaginationComponent,
    NgxSkeletonLoaderModule,
    NoContentComponent,
    SupplierCardSkeletonComponent,
  ],
  templateUrl: './cards-list.component.html',
  styleUrl: './cards-list.component.scss',
})
export class CardsListComponent implements OnInit {
  public allSuppliersCount!: number;
  public suppliersList!: IBusiness[];
  public isLoading!: boolean;
  public currentPath!: string;
  public listTabs: string[] = industriesSortItems;

  // dependencies
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _suppliersService = inject(SuppliersService);

  constructor() {
    // set current path
    this._activatedRoute.url.subscribe(url => {
      this.currentPath = url?.[0]?.path?.toUpperCase();
    });

    effect(() => {
      // set loading state
      this.isLoading = this._suppliersService.isSuppliersLoading();

      // get data
      this.suppliersList = this._suppliersService.suppliersList();

      // get data count
        this.allSuppliersCount = this._suppliersService.allSuppliersCount() as number;
    });
  }

  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe(params => {
      // pagination params
      const take = params['perPage'] || 12;
      const skip = params['page'] ? (Number(params['page']) - 1) * take : 0;

      // implement params object
      const selectedParams: Params = {
        ...params,
        type: this.currentPath,
        take,
        skip,
      };

      // get business data
      this.getBusinessesData(selectedParams);
    });
  }

  public getBusinessesData(params: Params) {
    // fetch data from server
    this._suppliersService.getAllSuppliers(params);
  }
}
